import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { WidgetTemplatesListResponse } from "@src/types/dashboards";

export const getWidgetTemplatesV2 = async (
  namespace: string,
): Promise<{ data: WidgetTemplatesListResponse }> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<WidgetTemplatesListResponse>(
      `${url}/api/v2/ns/${namespace}/widget-templates`,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch widget templates. Please try again later.",
      );
    }
    throw new Error(
      "An unexpected error occurred while fetching widget templates.",
    );
  }
};
